import { ApiUserRole } from '@/core/generated/api';

type RoleCodeListener = (roleCode: ApiUserRole | null) => void;

const roleCodeListeners = new Set<RoleCodeListener>();

if (typeof window !== 'undefined') {
    window.addEventListener('storage', (event) => {
        if (event.storageArea !== localStorage) return;

        const isSessionKey = event.key === null || event.key === 'refreshToken' || event.key === 'roleCode';

        if (isSessionKey) notifyRoleCodeChanged(getRoleCode());
    });
}

/** Оповещает подписчиков о смене роли сотрудника */
const notifyRoleCodeChanged = (roleCode: ApiUserRole | null) => {
    roleCodeListeners.forEach((listener) => listener(roleCode));
};

/** Подписывает состояние приложения на изменение кода роли текущего пользователя */
export const subscribeRoleCode = (listener: RoleCodeListener) => {
    roleCodeListeners.add(listener);

    return () => {
        roleCodeListeners.delete(listener);
    };
};

/** Сохраняет токены и данные текущего пользователя */
export const setTokens = (
    accessToken: string,
    refreshToken: string,
    userId: string | null | undefined,
    login: string | null | undefined,
    role: string | null | undefined,
    roleCode: ApiUserRole | null | undefined,
) => {
    if (accessToken) localStorage.setItem('authToken', accessToken);
    if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
    if (userId) localStorage.setItem('appUserId', userId);
    if (login) localStorage.setItem('login', login);
    if (role) localStorage.setItem('role', role);
    if (roleCode) localStorage.setItem('roleCode', roleCode);
    else localStorage.removeItem('roleCode');
    notifyRoleCodeChanged(roleCode ?? null);
};

/** Возвращает access token текущей сессии */
export const getAccessToken = (): string | null => {
    return localStorage.getItem('authToken');
};

/** Возвращает refresh token текущей сессии */
export const getRefreshToken = (): string | null => {
    return localStorage.getItem('refreshToken');
};

/** Возвращает идентификатор текущего пользователя */
export const getUserId = (): string | null => {
    return localStorage.getItem('appUserId');
};

/** Возвращает стабильный код роли текущего пользователя */
export const getRoleCode = (): ApiUserRole | null => {
    const value = localStorage.getItem('roleCode');

    return Object.values(ApiUserRole).find((role) => role === value) ?? null;
};

/** Очищает данные текущей сессии */
export const clearTokens = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('appUserId');
    localStorage.removeItem('login');
    localStorage.removeItem('role');
    localStorage.removeItem('roleCode');
    notifyRoleCodeChanged(null);
};
